var React = require('react');

function Droplet (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","d":"M8.095 1.526l4.313 4.312a6.095 6.095 0 1 1-8.618 0l4.305-4.312z"}));
}

Droplet.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 16 18"};

module.exports = Droplet;

Droplet.default = Droplet;
